import { List, Create, Edit, View, MyPreSanction, Copy } from "../Components/index.js";

export default [
    {
        path: "/store/voucher/my-pre-sanction",
        component: MyPreSanction,
        name: "store.voucher.my.pre-sanction",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/voucher/pre-sanction",
        component: List,
        name: "store.voucher.pre-sanction",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/voucher/pre-sanction/create",
        component: Create,
        name: "store.voucher.pre-sanction.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/voucher/pre-sanction/:id/edit",
        component: Edit,
        name: "store.voucher.pre-sanction.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/voucher/pre-sanction/:id/view",
        component: View,
        name: "store.voucher.pre-sanction.view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/voucher/pre-sanction/:id/copy",
        component: Copy,
        name: "store.voucher.pre-sanction.copy",
        meta: {
            requiresAuth: true,
        },
    },
];
